class Reference {
  constructor (id, name, text) {
    this.id = id
    this.name = name
    this.text = text
  }
}

export default Reference
